// Partículas de nome que não contam como inicial ("Ana de Souza" vira AS).
const PARTICLES = new Set(['de', 'da', 'do', 'dos', 'das']);

/**
 * Iniciais para o avatar de quem não tem foto: a primeira letra do primeiro e
 * do último nome, em maiúsculas. Um nome só dá uma letra. Nome vazio ou sem
 * letra nenhuma (só o número do telefone) devolve vazio, e quem chama mostra o
 * ícone de pessoa no lugar.
 */
export function initialsOf(name: string | null | undefined): string {
  const words = (name ?? '').trim().split(/\s+/);
  const named = words.filter((word) => !PARTICLES.has(word.toLowerCase()));
  // Apelido que é só a partícula ("Da") continua valendo como nome.
  const letters = (named.length > 0 ? named : words)
    .map((word) => word.match(/\p{L}/u)?.[0] ?? '')
    .filter(Boolean);
  const first = letters[0];
  if (!first) return '';
  const last = letters.length > 1 ? (letters[letters.length - 1] ?? '') : '';
  return (first + last).toLocaleUpperCase('pt-BR');
}
